import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { Scorecard } from '@/typings/scorecard';
import { computed, onMounted, PropType, ref, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  scorecard: {
    type: Object as PropType<Scorecard>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { scorecard } = toRefs(props);

const imgPath = computed(
  () => process.env.VUE_APP_IMAGE_PATH + scorecard.value.CoverImage
);

const backupPath = computed(
  () => `${process.env.VUE_APP_IMAGE_PATH}/event-default.png`
);

const path = ref('');

onMounted(() => {
  path.value = imgPath.value;
});

function onError() {
  path.value = backupPath.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "h-auto max-w-full",
    src: path.value,
    onerror: onError
  }, null, 8, _hoisted_1))
}
}

})